import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import momentJalaali from 'moment-jalaali';






export default class SingleShamsiDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arivaldate: null,
            arivalfocused: null,
        }

        momentJalaali.loadPersian()
    }
    render() {
        let newdate = new Date();
        let today = momentJalaali(newdate).format("jYYYY-jMM-jDD");
        return (
            <div>
                <SingleDatePicker
                    date={this.state.arivaldate} // momentPropTypes.momentObj or null
                    onDateChange={date => {
                        this.setState({ arivaldate: date })
                        this.props.set(momentJalaali(date).format("YYYY-MM-DD"))
                    }
                    } // PropTypes.func.isRequired
                    focused={this.state.arivalfocused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ arivalfocused: focused })} // PropTypes.func.isRequired
                    id="arrivaldate" // PropTypes.string.isRequired,
                    renderMonthText={month => momentJalaali(month).format('jMMMM jYYYY')}
                    renderDayContents={day => momentJalaali(day).format('jD')}
                    displayFormat={'YYYY-MM-DD'}
                    placeholder='تاریخ رفت'
                    hideKeyboardShortcutsPanel={true}
                // keepOpenOnDateSelect={true}
                />
                {/* {console.log(this.state.arivalfocused)} */}
                {this.state.arivalfocused != null && this.state.arivalfocused === true &&
                    <div className='Today-date-change'>
                        <span className='date-of-today'>
                            امروز : <span>{today}</span>
                        </span>
                        {/* <span className='change-to-persian'>
                            <Button color="secondary" onClick={() => {
                                console.log('555')
                                // this.props.set();
                            }} >Persian Calender</Button>
                        </span> */}
                    </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Calendar/SingleShamsiDate.jsx